import { Frame } from '@/marketing/Frame';
import { Reveal, Stagger, StaggerItem } from '@/lib/motion';

const POINTS = [
  {
    k: 'One ticker',
    v: 'Buy and sell it like any stock, in the brokerage account you already use. No new platform, no onboarding maze.',
  },
  {
    k: 'No minimums, no lockups',
    v: 'No hedge-fund gate and no capital locked away. Start with what you have and stay liquid.',
  },
  {
    k: 'Transparent by design',
    v: 'Holdings and methodology you can actually inspect. The fund is built to be explained, not hidden.',
  },
];

export function Access() {
  return (
    <Frame id="access" label="Access">
      <div className="max-w-3xl">
        <Reveal>
          <h2 className="font-display text-[clamp(2rem,4.5vw,3.25rem)] font-bold leading-[1.03] tracking-[-0.02em] text-foreground">
            The whole engine.{' '}
            <span className="text-[color:var(--nq-gold)]">One ticker.</span>
          </h2>
        </Reveal>
      </div>

      <Stagger className="mt-14 flex flex-col">
        {POINTS.map((p) => (
          <StaggerItem key={p.k}>
            <div className="grid grid-cols-1 items-start gap-3 border-t border-white/8 py-7 md:grid-cols-[minmax(0,22rem)_1fr] md:gap-10">
              <h3 className="font-display text-xl font-semibold text-foreground">
                {p.k}
              </h3>
              <p className="max-w-xl text-[15px] leading-relaxed text-muted-foreground">
                {p.v}
              </p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>

      <p className="mt-8 max-w-xl text-xs text-white/35">
        Fund structure, fees, and availability will be defined in official ETF
        disclosures and regulatory filings.
      </p>
    </Frame>
  );
}
